import { CampaignFormProvider } from './hooks/useCampaignForm'

export function withCampaignFormProvider<P extends object>(
  Component: React.ComponentType<P>
) {
  const WithProvider: React.FC<P> = props => (
    <CampaignFormProvider>
      <Component {...props} />
    </CampaignFormProvider>
  )

  WithProvider.displayName = `withCampaignFormProvider(${
    Component.displayName || Component.name || 'Component'
  })`

  return WithProvider
}
